<template>
    <div>
        <b-button
            variant="success"
            @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Previsão de Atendimento
            </span>
        </b-button>
        <meta-form
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            :evento="evento"
            @fechar="fecharModal()"
            @salvar="inserirMeta($event)"
            @atualizarLista="$emit('atualizarLista')"
        ></meta-form>
    </div>
</template>

<script>
import MetaForm from './MetaForm'

export default {
    props: {
        evento: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },
    },

    components: {
        MetaForm
    },
    
    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
    },
}
</script>
